import type { components } from '@fluencelabs/vodopad-admin-api'
import { Alert, Card, Col, Empty, Row, Space, Statistic } from 'antd'

import { StatusTag } from '@/components/common/StatusTag'

type AdminDashboardDto = components['schemas']['AdminDashboardDto']

export function PlatformOverview({
  stats,
  loading,
  error,
}: {
  stats?: AdminDashboardDto
  loading: boolean
  error: boolean
}) {
  if (error && !stats) {
    return (
      <Alert
        type="error"
        message="Failed to load platform totals"
        showIcon
        style={{ marginTop: 16 }}
      />
    )
  }

  return (
    <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
      <Col xs={24} lg={14}>
        <Card title="Platform Totals" loading={loading}>
          <Row gutter={[16, 16]}>
            <Col xs={12} sm={8}>
              <Statistic title="VMs" value={stats?.vmsTotal} />
            </Col>
            <Col xs={12} sm={8}>
              <Statistic title="Storages" value={stats?.storagesTotal} />
            </Col>
            <Col xs={12} sm={8}>
              <Statistic title="Public IPs" value={stats?.publicIpsTotal} />
            </Col>
            <Col xs={12} sm={8}>
              <Statistic title="Subnets" value={stats?.subnetsTotal} />
            </Col>
            <Col xs={12} sm={8}>
              <Statistic title="VPCs" value={stats?.vpcsTotal} />
            </Col>
            <Col xs={12} sm={8}>
              <Statistic title="Active Users" value={stats?.usersActive} />
            </Col>
          </Row>
        </Card>
      </Col>
      <Col xs={24} lg={10}>
        <Card
          title="VMs by Status"
          loading={loading}
          style={{ height: '100%' }}
        >
          {stats?.vmsByStatus.length ? (
            <Space size={[8, 12]} wrap>
              {stats.vmsByStatus.map((entry) => (
                <Space key={entry.status} size={4}>
                  <StatusTag status={entry.status} />
                  <strong>{entry.count}</strong>
                </Space>
              ))}
            </Space>
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No VMs" />
          )}
        </Card>
      </Col>
    </Row>
  )
}
